// Semantic status scale (report score, badges, bars). Dark tokens per design spec.
// Bands: Fragile/High 0–39 · Developing/Medium 40–69 · Resilient/Low 70–100.
// Reserve red/amber for risk. Teal is brand/CTA only — never a status colour here.
// Light-mode colours come from the utility classes; the `rs-*` marker classes carry
// the dark-mode hex tokens via scoped rules in index.css (override-proof).
export function statusBand(score) {
  if (score >= 70) {
    return {
      label: "Resilient",
      number: "text-emerald-600 rs-num-res",
      pill: "bg-emerald-500/10 text-emerald-700 rs-pill-res",
      bar: "bg-emerald-500 rs-bar-res",
      leftBorder: "border-l-emerald-500 rs-left-res",
    };
  }
  if (score >= 40) {
    return {
      label: "Developing",
      number: "text-amber-600 rs-num-dev",
      pill: "bg-amber-500/10 text-amber-700 rs-pill-dev",
      bar: "bg-amber-500 rs-bar-dev",
      leftBorder: "border-l-amber-500 rs-left-dev",
    };
  }
  return {
    label: "Fragile",
    number: "text-red-600 rs-num-fra",
    pill: "bg-red-500/10 text-red-700 rs-pill-fra",
    bar: "bg-red-500 rs-bar-fra",
    leftBorder: "border-l-red-500 rs-left-fra",
  };
}

// Shared neutral card + text tokens.
export const CARD = "bg-white border-slate-200 rs-card";
export const TXT_PRIMARY = "text-slate-900 rs-txt-primary";
export const TXT_BODY = "text-slate-600 rs-txt-body";
export const TXT_MUTED = "text-slate-500 rs-txt-muted";
